import React from 'react'
import AdminContainer from '../../../../../Components/UserPart/UserList/AdminContainer/AdminContainer'
import Layout from '../../../Layout'

const AdminPart = () => {
  return (
    <Layout>
      <AdminContainer/>
    </Layout>
  )
}

export default AdminPart